import { r as o, h as t } from "./index-6e735f92.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const e = ".sc-italic-icon-h{display:flex}", s = e, c = class {
  constructor(i) {
    o(this, i), this.width = "15", this.height = "15";
  }
  render() {
    return t("svg", { key: "4a7c601a716d0aaf0c1c96a9721a7e4db7b713ce", width: this.width, height: this.height, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, t("path", { key: "460d17d1c5215d2b2bf07d8e60a0cc397d3ad230", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "2", d: "m10 20 4-16m2 0h-4m0 16H8" }));
  }
};
c.style = s;
export {
  c as italic_icon
};
